
export const extension = {
  'extension.assistant': 'Assistant AgriTool',
  'extension.appAssistant': 'Assistant de Demande',
  'extension.appAssistantDesc': 'Nous avons détecté que vous remplissez une demande de subvention UE',
  'extension.appCompletion': 'Achèvement de la demande',
  'extension.letsHelp': 'Aidons-vous à compléter cette demande.',
  'extension.almostComplete': 'Super ! Votre formulaire est presque complet — terminons-le ensemble.',
  'extension.excellent': 'Excellent ! Votre demande est complète et prête à être soumise.',
  'extension.autofillProfile': 'Remplir automatiquement depuis le Profil de la Ferme',
  'extension.requiredDocs': 'Documents Requis',
  'extension.useCompletedPDF': 'Utiliser le PDF Complété d\'AgriTool',
  'extension.fillFormHelp': 'Je peux vous aider à remplir ce formulaire en utilisant les données de votre profil de ferme.',
  'extension.goodStart': 'Vous avez bien commencé ! J\'ai suggéré du texte pour les champs restants.',
  'extension.greatProgress': 'Excellent progrès ! Vous devez encore télécharger le formulaire de déclaration d\'irrigation avant de soumettre.',
  'extension.perfect': 'Parfait ! Votre demande est complète. Vous pouvez maintenant la soumettre au portail de l\'UE.',
  'extension.reviewReminder': 'N\'oubliez pas de revoir tous les détails avant la soumission finale',
  'extension.readyToSubmit': 'Prêt à Soumettre',
} as const;
